/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Label, Input, Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import Toggle from 'react-toggle';
import Alert from 'react-s-alert';
import QRCode from "react-qr-code"
import moment from 'moment';
import ReactToPDF from 'react-to-pdf';
import jsPDF from 'jspdf';
import qrcode from 'qrcode';
import html2canvas from 'html2canvas';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

import Logo from '../../assets/UW_Horizontal_Logo_Full.png';
import ProviderInviteBackgroundTop from '../../assets/providerInviteBackgroundTop.jpeg';
import ProviderInviteBackgroundBottom from '../../assets/providerInviteBackgroundBottom.jpeg';

const ScrapedCounsellorProfiles = (props) => {

    // variables
    let timeout = 0;
    const inviteRef = React.createRef();

    //states
    const [confirmationModal, setConfirmationModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({ limit: 20, page: 1, search: '' });
    const [scrapeProviderProfile, setScrapeProviderProfile] = useState([]);
    const [modal, setModal] = useState({ isVisible: false, selectedIndex: -1, selectedName: "", selectedUniqueId: "" });
    const [inviteLink, setInviteLink] = useState();
    const [PDFModal, setPDFModal] = useState({
        isVisible: false,
        isEditing: false,
        content: {
            title: "Invitation",
            line1: moment().format("DD-MM-YYYY"),
            line2: "Greetings of the highest order!",
            line3: "It is our great pleasure to extend to you an invitation to join the Umang Wellness platform as a provider of psychological counselling services. We humbly request that you scan the QR code below to discover more about the platform and take ownership of your dedicated profile page.",
            line4: "We eagerly anticipate your presence on Umang Wellness, and we hope to gain a deeper understanding of how our platform can be of benefit to you.",
            line5: "",
            line6: "With heartfelt appreciation,",
            line7: "Sincerely,",
            line8: "The Umang Wellness Team",
        }, 
        inviteQR: "", 
        selectedIndex: -1, 
        selectedName: "", 
        selectedUniqueId: ""});

    // contexts
    const { theme } = useContext(ThemeContext);

    useEffect(() => {
        if (!isLoading) {
            setIsLoading(true);
            AdminService.getScrapeProviderProfiles(pagination.limit, pagination.page, pagination.search, '').then(data => {
                try {
                    setScrapeProviderProfile(data.scrapeProviderProfiles);
                    if (data.pagination.totalPages <= data.pagination.page) {
                        data.pagination.page = data.pagination.totalPages;
                    }
                    setPagination(data.pagination);
                    setIsLoading(false);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    // GeneralService.logError('at Admin Clients useEffect', 'Error in try catch block', err.stack);
                    setIsLoading(false);
                }
            });
        }
    }, [pagination.page, pagination.limit, pagination.search]);

    const openModal = (index, name, uniqueId) => {
        try {
            setModal({ isVisible: true, selectedIndex: index, selectedName: name, selectedUniqueId: uniqueId });
            const inviteLink = `https://www.umangwellness.com/counsellors/unclaimedProfile/${uniqueId}`;
            setInviteLink(inviteLink);

        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Admin Clients showDetails', 'Error in try catch block', err.stack);
        }
    };

    // Flow for counsellor invite:
    // Scan the code #
    // Navigate to page which shows what they will get out of UmangWellness #
    // Next will be features page #
    // And a static profile page with demo information 
    // And thier actual profile at last, which will show them a guided tour on how to update it

    const openPDFInviteModal = async (index, name, uniqueId) => {
        try {
            const inviteLink = `https://www.umangwellness.com/counsellors/benefits?scannedInvite=${uniqueId}}`;
            // const inviteLink = `https://www.umangwellness.com/counsellors/unclaimedProfile/${uniqueId}?scannedInvite=true`;
            const inviteQR = await qrcode.toDataURL(inviteLink);
            setPDFModal({ ...PDFModal, isVisible: true, inviteQR: inviteQR, selectedIndex: index, selectedName: name, selectedUniqueId: uniqueId });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Admin Clients showDetails', 'Error in try catch block', err.stack);
        }
    };

    const handleSearch = e => {
        try {
            let value = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, search: value });
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handleSerach', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handlePagination', 'Error in try catch block', err.stack);
        }
    }

    const handleToggleChange = (index) => {
        try {
            // console.log(index);
            let tempScrapeProviderProfiles = [...scrapeProviderProfile];
            tempScrapeProviderProfiles[index].profileStatus = tempScrapeProviderProfiles[index].profileStatus === 'claimed' ? 'unclaimed' : 'claimed';
            setScrapeProviderProfile(tempScrapeProviderProfiles);
            AdminService.setActiveStatusScrapeProvider(tempScrapeProviderProfiles[index].uniqueId, tempScrapeProviderProfiles[index].profileStatus)
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setConfirmationModal({ isVisible: false, selectedIndex: -1 });
                })
                .catch(error => {
                    console.log(error);
                });
        } catch (err) {
            console.log(err);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            //GeneralService.logError('at Admin Clients handleToggleChange', 'Error in try catch block', err.stack);
        }
    }
    //perform add profile
    const addProfile = () => {
        try {
            props.history.push("/admin/dashboard/addCounsellorProfileIndividual")
        } catch (err) {
            console.log('err', err)
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            })
        }
    }

    const handleTextAreaResize = (e) => {
        e.target.style.height = 'auto';
        e.target.style.height = e.target.scrollHeight + 'px';
    }

    const handlePDFContentChange = (e) => {
        setPDFModal({ ...PDFModal, content: {...PDFModal.content, [e.target.name]: e.target.value }});
    }

    const handleGeneratePDF = (e) => {
        e.preventDefault();
        let doc = new jsPDF();
        let elementHTML = document.getElementById('invitePreview');
        doc.html(elementHTML, {
            callback: function (doc) {
                doc.save('invite.pdf');
            },
            x: 0,
            y: 0,
            width: 210,
            windowWidth: 735
        })
    }

    const handleInvite = (e) => {
        e.preventDefault()
        try {
            setIsLoading(true)
            AdminService.postScrapeProviderSendInvite(modal.selectedUniqueId)
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading(false);
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    // console.log(error.message);
                    setIsLoading(false);
                })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin CounsellorProfile handleInvite', 'Error in try catch block', err.stack);
            setIsLoading(false);
            console.log(err);
        }
        setModal({ isVisible: false })
    }

    return (
        <main>
            <div className='container-fluid'>
                <div className='my-4 d-flex'>
                    <h3>Scraped Counsellor Profiles</h3>
                </div>
                <hr />
                <div className='card mb-4'>
                    <div className='card-header d-flex'>
                        <label className="my-auto">Profiles</label>
                        <Button className="ml-auto my-auto px-3" type="button" style={Object.assign({ height: 'fit-content' }, theme.formButton)} onClick={() => { addProfile() }}>Add Profiles</Button>
                        {/* <Button className="my-auto px-3" type="button" style={Object.assign({ height: 'fit-content' }, theme.formButton)} onClick={() => generateQRCode("www.google.com")}>test</Button> */}
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <td colSpan="9" className="border-0 px-0">
                                            <div className="d-flex">
                                                <div className="ml-auto">
                                                    Search<input type="text" id="searchInput" className="ml-2" style={{ marginRight: "-20px", paddingRight: "20px" }} onChange={handleSearch}></input>
                                                    <span style={{ cursor: "pointer", marginRight: "18px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("searchInput").value = ""; setPagination({ ...pagination, search: "" }); }}><i className="fa fa-times"></i></span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Counsellor Name</th>
                                        <th>Address</th>
                                        <th>Phone</th>
                                        <th>Website</th>
                                        <th>Profile Link</th>
                                        <th>Edit Service</th>
                                        <th align="center" style={{ width: '185px' }}>Status</th>
                                        <th colSpan={2} className="text-center">Invite</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        scrapeProviderProfile.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.name}</td>
                                                <td>{item.address}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.website}</td>
                                                <td>{"https://www.umangwellness.com/counsellors/unclaimedProfile/" + item.uniqueId}</td>
                                                <td align="center"><a style={{ color: "#384E73", cursor: "pointer" }}
                                                    onClick={() => props.history.push({
                                                        pathname: "/admin/dashboard/editCounselorProfileIndividual", state: {
                                                            provider: {
                                                                name: item.name,
                                                                address: item.address,
                                                                phone: item.phone,
                                                                uniqueId: item.uniqueId
                                                            }
                                                        }
                                                    })}
                                                >Edit</a></td>
                                                <td align="center"><Toggle icons={false} checked={item.profileStatus === 'claimed'} onChange={() => setConfirmationModal({ isVisible: true, selectedIndex: index })} /></td>
                                                <td>{
                                                    item.email === "" ? "Email is Not Provided" : 
                                                    <a href='#' onClick={() => openModal(index, item.name, item.uniqueId)}>Send Invitation</a>
                                                }</td>
                                                <td>
                                                    <a href="#" onClick={() => openPDFInviteModal(index, item.name, item.uniqueId)}>Generate PDF Invite</a>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="8" className="border-0 pb-0 px-0">
                                            <div className="d-flex">
                                                <ErrorBoundary errorAt="At Admin Services Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <Modal isOpen={modal.isVisible} backdrop={true} size="lg">
                        <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false, selectedIndex: -1 })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Send Invitation</span></ModalHeader>
                        <br />
                        <ModalBody>
                            <h5>Email Subject</h5>
                            <div className='px-2' disabled style={{ background: "#DADADA", borderRadius: "2px" }}>
                                <p className='py-1'>
                                    Invitation to Counselling on Umang Wellness
                                </p>
                            </div>
                            <br />
                            <h5>Email Body</h5>
                            <div className='px-2' disabled style={{ background: "#DADADA", borderRadius: "2px" }}>
                                <p className='pt-1'>Dear {modal.selectedName},</p>
                                <p>We are inviting you to Umang Wellness platform to provide your counselling services for mental health.</p>
                                <p>Your profile is unverified.</p>
                                <p>Kindly visit your profile page - {inviteLink} to claim it.</p>
                                <p>Or you can scan the below QR code to claim your profile.</p>
                                <div style={{ padding: "2px 2px" }}>
                                    <QRCode
                                        value={inviteLink}
                                        bgColor="#FFFFFF"
                                        fgColor="#000000"
                                        size={150}
                                    />
                                </div>
                                <div className='pb-1'>
                                    <p>Yours sincerely, <br />
                                        Umang Wellness Support</p>
                                </div>
                            </div>
                            <Button style={{ background: "#384E73" }} className="mt-2" onClick={handleInvite}>Send Invitation</Button>

                        </ModalBody>
                    </Modal>

                    <Modal isOpen={PDFModal.isVisible} backdrop={true} size="lg">
                        <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setPDFModal({ ...PDFModal, isVisible: false })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Invitation preview</span></ModalHeader>
                        <br />
                        <ModalBody style={{overflow: 'auto', alignSelf: 'center'}}>
                            <div style={{position: 'relative', width: '735px', height: '1038px'}} ref={inviteRef} id="invitePreview">
                                <img src={ProviderInviteBackgroundTop} style={{width: "42%", position: "absolute", top: 0, left: 0}}/>
                                <img src={ProviderInviteBackgroundBottom} style={{width: "42%", position: "absolute", bottom: 0, right: 0}}/>
                                <img src={Logo} style={{width: "28%", position: "absolute", top: 15, right: 15}} />
                                <div className='d-flex h-100' style={{ fontSize: '1.2rem'}}>
                                    <div className='my-auto mx-5 w-100'>
                                        {
                                            PDFModal.isEditing ?
                                                <div className='text-center'><h3><Input className='text-center w-100 p-0' style={{font: 'inherit', height: 'auto'}} placeholder='Type here' name='title' value={PDFModal.content.title} onChange={handlePDFContentChange} /></h3></div>
                                                : 
                                                PDFModal.content.title ?
                                                    <div className='text-center'><h3>{PDFModal.content.title}</h3></div>
                                                : null
                                        }
                                        {
                                            PDFModal.isEditing ?
                                                <div className='mt-3'><Input className='p-0' style={{font: 'inherit', height: 'auto'}} placeholder='Type here' name='line1' value={PDFModal.content.line1} onChange={handlePDFContentChange} /></div>
                                                :
                                                PDFModal.content.line1 ?
                                                    <div className='mt-3'>{PDFModal.content.line1}</div>
                                                : null
                                        }
                                        <div className='mt-3'>Dear {PDFModal.selectedName},</div>
                                        {
                                            PDFModal.isEditing ?
                                                <div className='mt-3'><Input className='p-0' style={{font: 'inherit', height: 'auto'}} type='textarea' placeholder='Type here' name='line2' value={PDFModal.content.line2} onInput={handleTextAreaResize} onChange={handlePDFContentChange} /></div>
                                                :
                                                PDFModal.content.line2 ?
                                                    <div className='mt-3'>{PDFModal.content.line2}</div>
                                                : null
                                        }
                                        {
                                            PDFModal.isEditing ?
                                                <div className='mt-3'><Input className='p-0' style={{font: 'inherit', height: 'auto'}} type='textarea' placeholder='Type here' name='line3' value={PDFModal.content.line3} onInput={handleTextAreaResize} onChange={handlePDFContentChange} /></div>
                                                :
                                                PDFModal.content.line3 ?
                                                    <div className='mt-3'>{PDFModal.content.line3}</div>
                                                : null
                                        }
                                        {
                                            PDFModal.inviteQR ?
                                                <div className='mt-3'>
                                                    <img width={150} height={150} src={PDFModal.inviteQR} />
                                                </div>
                                                : null
                                        }
                                        {
                                            PDFModal.isEditing ?
                                                <div className='mt-3'><Input className='p-0' style={{font: 'inherit', height: 'auto'}} type='textarea' placeholder='Type here' name='line4' value={PDFModal.content.line4} onInput={handleTextAreaResize} onChange={handlePDFContentChange} /></div>
                                                :
                                                PDFModal.content.line4 ?
                                                    <div className='mt-3'>{PDFModal.content.line4}</div>
                                                : null
                                        }
                                        {
                                            PDFModal.isEditing ?
                                                <div className='mt-3'><Input className='p-0' style={{font: 'inherit', height: 'auto'}} type='textarea' placeholder='Type here' name='line5' value={PDFModal.content.line5} onInput={handleTextAreaResize} onChange={handlePDFContentChange} /></div>
                                                :
                                                PDFModal.content.line5 ?
                                                    <div className='mt-3'>{PDFModal.content.line5}</div>
                                                : null
                                        }
                                        {
                                            PDFModal.content.line6 || PDFModal.content.line7 || PDFModal.content.line8 || PDFModal.isEditing ?
                                            <div className='mt-3'>
                                                {
                                                    PDFModal.isEditing ?
                                                        <Input className='p-0' style={{font: 'inherit', height: 'auto'}} placeholder='Type here' name='line6' value={PDFModal.content.line6} onChange={handlePDFContentChange} />
                                                    :
                                                    PDFModal.content.line6 ? [
                                                        PDFModal.content.line6, <br key={2} />
                                                    ]: null
                                                }
                                                {
                                                    PDFModal.isEditing ?
                                                        <Input className='p-0' style={{font: 'inherit', height: 'auto'}} placeholder='Type here' name='line7' value={PDFModal.content.line7} onChange={handlePDFContentChange} />
                                                    :
                                                    PDFModal.content.line7 ? [
                                                        PDFModal.content.line7, <br key={2} />
                                                    ]: null
                                                }
                                                {
                                                    PDFModal.isEditing ?
                                                        <Input className='p-0' style={{font: 'inherit', height: 'auto'}} placeholder='Type here' name='line8' value={PDFModal.content.line8} onChange={handlePDFContentChange} />
                                                    :
                                                    PDFModal.content.line8 ?
                                                        PDFModal.content.line8
                                                    : null
                                                }
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                                 {/* style={{height: '100%', backgroundImage: `url(${ProviderInviteBackground})`, backgroundRepeat: 'no-repeat'}}> */}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            {
                                PDFModal.isEditing ?
                                <Button style={{ background: "#384E73" }} className="mt-2" onClick={() => setPDFModal({...PDFModal, isEditing: false})}>Preview</Button>
                                : [
                                    <Button key={1} style={{ background: "#384E73" }} className="mt-2" onClick={() => setPDFModal({...PDFModal, isEditing: true})}><i className='fas fa-edit'></i></Button>,
                                    <Button key={2} style={{ background: "#384E73" }} className="mt-2" onClick={handleGeneratePDF}>Generate PDF</Button>
                                ]
                            }
                        </ModalFooter>
                    </Modal>

                    <ErrorBoundary errorAt="At Admin Services Modal">
                        <Modal size="sm" isOpen={confirmationModal.isVisible} backdrop={true}>
                            <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setConfirmationModal({ isVisible: false, selectedIndex: -1 })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Are you sure?</span></ModalHeader>
                            <ModalBody>
                                {confirmationModal.selectedIndex >= 0 ?
                                    <Label>By clicking on Save button <b>{scrapeProviderProfile[confirmationModal.selectedIndex].name}</b> will be <b>{scrapeProviderProfile[confirmationModal.selectedIndex].profileStatus === 'unclaimed' ? "claimed" : "unclaimed"}</b>.</Label>
                                    : null}
                            </ModalBody>
                            <ModalFooter>
                                <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={() => handleToggleChange(confirmationModal.selectedIndex)} disabled={isLoading}>
                                    {isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Save
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </ErrorBoundary>
                </div>
            </div>
        </main >
    )

}
export default ScrapedCounsellorProfiles; 